/* HKI custom.js (2026-07-12, v2)
   Zentrale Funktion window.hkiOpenCartDrawer(): öffnet den Quick-Cart-Drawer über den
   nativen Theme-Handler am Header-Cart-Icon. Robust gegen Sticky-Header-Klone (die kein
   JS-Binding haben): probiert alle Icons; ob der Theme-Handler übernommen hat, erkennt
   man am defaultPrevented des Events. href wird während des Tests entfernt, damit ein
   Klon-Icon nicht zur /cart-Seite navigiert.
   Plus: globaler Interceptor — alle Links zur /cart-Seite öffnen stattdessen den Drawer. */
(function () {
  function openDrawer() {
    var icons = document.querySelectorAll('[data-js-cart-icon]');
    for (var k = 0; k < icons.length; k++) {
      var ic = icons[k];
      var href = ic.getAttribute('href');
      ic.removeAttribute('href');
      var evt = new MouseEvent('click', { bubbles: true, cancelable: true });
      ic.dispatchEvent(evt);
      /* href VERZÖGERT restaurieren: Chrome scheduled die Default-Navigation synthetischer
         Klicks asynchron — sofortiges Restore würde trotz preventDefault zur /cart navigieren */
      (function (el, h) { if (h !== null) setTimeout(function () { el.setAttribute('href', h); }, 400); })(ic, href);
      if (evt.defaultPrevented) return true; /* Theme-Handler hat den Drawer geöffnet */
    }
    return false;
  }
  window.hkiOpenCartDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (a.hasAttribute('data-js-cart-icon')) return; /* echtes Icon: Theme regelt es */
    var href = a.getAttribute('href') || '';
    if (!/^\/cart\/?(\?.*)?$/.test(href)) return;
    if (openDrawer()) {
      e.preventDefault();
      /* WICHTIG: Ausbreitung stoppen — der Seiten-Übergangs-Loader des Themes
         (theme.min.js) fängt sonst denselben Klick und navigiert nach 200ms
         programmatisch zur /cart-Seite (er ignoriert preventDefault). */
      e.stopImmediatePropagation();
      e.stopPropagation();
      /* Gürtel + Hosenträger: href kurz entfernen, damit auch eine verzögert
         geplante Default-Navigation ins Leere läuft (Chrome-Eigenheit bei
         synthetischen Klicks). Nach 600ms wiederherstellen. */
      var h = a.getAttribute('href');
      a.removeAttribute('href');
      setTimeout(function () { a.setAttribute('href', h); }, 600);
    }
    /* sonst: normale Navigation als Fallback */
  }, true);
})();


/* Quick-View: lange Produktbeschreibung einklappen + "Mehr anzeigen"-Toggle (2026-07-12).
   Das Quick-View-HTML wird dynamisch geladen → MutationObserver statt Einmal-Init. */
(function () {
  function enhance(desc) {
    if (!desc || desc.dataset.ppDesc) return;
    desc.dataset.ppDesc = '1';
    if (desc.scrollHeight <= 140) return; /* kurz genug — nichts tun */
    desc.classList.add('pp-desc-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pp-desc-toggle';
    btn.textContent = 'Mehr anzeigen';
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var collapsed = desc.classList.toggle('pp-desc-collapsed');
      btn.textContent = collapsed ? 'Mehr anzeigen' : 'Weniger anzeigen';
    });
  }
  function scan() {
    document.querySelectorAll('.quick-view-modal__content .product__description').forEach(enhance);
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();

/* === Klaviyo Customer Hub: englischen Abgemeldet-Titel eindeutschen (24.07.2026) ===
   Der Hub-Inhalt ist in der Klaviyo-App fuer den Abgemeldet-Zustand nicht editierbar,
   darum ersetzen wir den Text clientseitig. Exakter Textvergleich, damit keine
   anderen kl-hub-Ueberschriften betroffen sind. */
(function () {
  var REPLACEMENTS = {
    'Sign in to view your orders': 'Melde dich an, um deine Bestellungen zu sehen'
  };
  function hkiFixKlaviyoHubTexts(root) {
    (root || document).querySelectorAll('.kl-hub-heading').forEach(function (el) {
      var t = el.textContent.trim();
      if (REPLACEMENTS[t]) el.textContent = REPLACEMENTS[t];
    });
  }
  var mo = new MutationObserver(function () { hkiFixKlaviyoHubTexts(); });
  document.addEventListener('DOMContentLoaded', function () {
    hkiFixKlaviyoHubTexts();
    mo.observe(document.body, { childList: true, subtree: true });
  });
  if (document.readyState !== 'loading') {
    hkiFixKlaviyoHubTexts();
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();

/* ═══ Newsletter-Fallback, wenn Klaviyo nicht lädt (2026-09-14) ═══
   Elias: "bei der über uns seite oder auch bei anderen lädt newsletter manchmal nicht".
   Gemessen: Klaviyo zieht 21 Script-Dateien nach, das Formular erscheint erst nach
   ~1 s (schnelle Leitung). Bis dahin ist der Container leer und hoch 0 — die Seite
   springt. Bleibt Klaviyo ganz aus (langsame Verbindung, Skript-Blocker, Ausfall),
   steht dort kommentarlos nichts.
   Darum: Container bekommt per CSS eine Mindesthöhe, und nach 6 s ohne Formular
   erscheint ein Hinweis mit Link auf die Newsletter-Seite. */
(function () {
  var WARTEZEIT_MS = 6000;
  var AUSWAHL = '.newsletter-cta__form, .section-blocks__klaviyo-form';

  function hatFormular(el) {
    return !!el.querySelector('form, input[type="email"]');
  }

  function zeigeFallback(el) {
    if (el.querySelector('.hki-newsletter-fallback')) return;
    var box = document.createElement('div');
    box.className = 'hki-newsletter-fallback';
    box.innerHTML =
      '<p>Das Anmeldeformular l\u00E4dt gerade nicht. ' +
      '<a href="/pages/newsletter">Hier geht es zur Newsletter-Anmeldung</a>.</p>';
    el.appendChild(box);
  }

  function hkiNewsletterFallback() {
    var ziele = document.querySelectorAll(AUSWAHL);
    Array.prototype.forEach.call(ziele, function (el) {
      if (el.getAttribute('data-hki-nl-geprueft')) return;
      el.setAttribute('data-hki-nl-geprueft', '1');
      el.classList.add('hki-newsletter-wartet');

      var fertig = false;
      function pruefen() {
        if (fertig) return;
        if (hatFormular(el)) {
          fertig = true;
          el.classList.remove('hki-newsletter-wartet');
          var f = el.querySelector('.hki-newsletter-fallback');
          if (f) f.remove();
          if (beobachter) beobachter.disconnect();
          window.clearInterval(takt);
        }
      }

      var beobachter = new MutationObserver(pruefen);
      beobachter.observe(el, { childList: true, subtree: true });
      var takt = window.setInterval(pruefen, 250);

      window.setTimeout(function () {
        window.clearInterval(takt);
        if (fertig) return;
        if (hatFormular(el)) { pruefen(); return; }
        el.classList.remove('hki-newsletter-wartet');
        zeigeFallback(el);
      }, WARTEZEIT_MS);

      pruefen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hkiNewsletterFallback);
  } else {
    hkiNewsletterFallback();
  }
})();

/* ═══ Eigenes Newsletter-Formular statt Klaviyo-Embed (2026-09-16) ═══
   Elias: "das newsletter form embed laedt einfach echt mega lange".
   Gemessen: Klaviyo zieht 21 Skriptdateien nach, bis das Formular steht.
   Dieses Formular ist sofort im HTML da und meldet per fetch direkt an der
   Klaviyo-Client-API an. Double-Opt-in, Listenzuordnung und Willkommens-Flow
   bleiben unveraendert — Klaviyo verschickt die Bestaetigungsmail wie bisher.
   Der Public Key im Markup ist dafuer vorgesehen: er kann nur anmelden, nichts lesen. */
(function () {
  var ENDPUNKT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2025-07-15';

  function gueltig(wert) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert.trim());
  }

  function melde(form, text, art) {
    var p = form.querySelector('.hki-nl__hinweis');
    if (!p) return;
    p.textContent = text;
    p.hidden = false;
    form.classList.remove('hki-nl--fehler', 'hki-nl--erfolg');
    form.classList.add('hki-nl--' + art);
  }

  function laedt(form, an) {
    var knopf = form.querySelector('.hki-nl__knopf');
    if (!knopf) return;
    knopf.disabled = an;
    var t = knopf.querySelector('.hki-nl__knopf-text');
    var l = knopf.querySelector('.hki-nl__knopf-laedt');
    if (t) t.hidden = an;
    if (l) l.hidden = !an;
  }

  function anmelden(form, email) {
    var firma = form.getAttribute('data-firma');
    var liste = form.getAttribute('data-liste');
    var koerper = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: liste } } }
      }
    };
    return fetch(ENDPUNKT + '?company_id=' + encodeURIComponent(firma), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(koerper)
    });
  }

  function hkiNativesNewsletterFormular() {
    var formulare = document.querySelectorAll('form.hki-nl');
    Array.prototype.forEach.call(formulare, function (form) {
      if (form.getAttribute('data-hki-gebunden')) return;
      form.setAttribute('data-hki-gebunden', '1');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var feld = form.querySelector('.hki-nl__feld');
        if (!feld) return;
        var email = feld.value.trim();

        if (!gueltig(email)) {
          melde(form, form.getAttribute('data-ungueltig') || 'Bitte gib eine g\u00FCltige E-Mail-Adresse ein.', 'fehler');
          feld.focus();
          return;
        }

        laedt(form, true);
        anmelden(form, email)
          .then(function (antwort) {
            laedt(form, false);
            /* Klaviyo antwortet auf eine erfolgreiche Anmeldung mit 202 ohne Inhalt. */
            if (antwort.ok || antwort.status === 202) {
              melde(form, form.getAttribute('data-erfolg') || 'Fast geschafft! Bitte best\u00E4tige die E-Mail, die wir dir geschickt haben.', 'erfolg');
              var reihe = form.querySelector('.hki-nl__reihe');
              if (reihe) reihe.hidden = true;
              /* Merker: Abschnitt beim nächsten Besuch nicht mehr zeigen (newsletter-cta, 29.09.2026) */
              try { localStorage.setItem('hki_nl_angemeldet', 'formular'); } catch (e) {}
            } else {
              melde(form, form.getAttribute('data-fehler') || 'Das hat gerade nicht geklappt.', 'fehler');
            }
          })
          .catch(function () {
            laedt(form, false);
            melde(form, form.getAttribute('data-fehler') || 'Das hat gerade nicht geklappt.', 'fehler');
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hkiNativesNewsletterFormular);
  } else {
    hkiNativesNewsletterFormular();
  }
})();
